import React, { Component } from 'react';
import { TableDefault, Breadcrumb, Tabs } from '../../../components';

export class List extends Component {
  constructor(props) {
    super(props);
    const { history } = this.props;
    let type = 1;
    if (Number(history.location.pathname.slice(-1)) === 2) {
      type = 2;
    }
    this.state = {
      search: '',
      page: 1,
      type,
      pageSize: 100,
      totalItems: 0,
      orderBy: 'grupo',
      order: '',
      urlDelete: null,
      urlEdit: '/admin/produto/',
      urlNew: null,
      urlLoad: '/Produto/GetListagem/',
      customDataFilter: {
        itens: [
          { id: 0, label: 'Todos' },
          { id: 1, label: 'Disponível' },
          { id: 2, label: 'Indisponível' },
        ],
        placeholder: 'Filtrar por Status',
        id: 'status',
        selected: { id: 0, label: 'Todos' },
      },
    };
  }

  componentWillMount = () => {
    const {  match, location } = this.props;
    const type = location.pathname.replace(match.url, '').replace('/', '');
    const urlLoad = parseInt(type, 10) === 1 ? '/ProdutoAgencia/GetListagem/' : '/Produto/GetListagem/';
    const urlNew = parseInt(type, 10) === 1 ? '/admin/produto-agencia/0' : '/admin/produto/0';
    const urlEdit = parseInt(type, 10) === 1 ? '/admin/produto-agencia/' : '/admin/produto/';
    // console.log(urlNew)
    this.setState({ type, urlLoad, urlNew, urlEdit });
  }

  componentDidMount = () => {
    const { history, match } = this.props;
    history.listen(location => {
      const type = location.pathname.replace(match.url, '').replace('/', '');

      const urlLoad = parseInt(type, 10) === 1 ? '/ProdutoAgencia/GetListagem/' : '/Produto/GetListagem/'
      const urlNew = parseInt(type, 10) === 1 ? '/admin/produto-agencia/0' : '/admin/produto/0';
      const urlEdit = parseInt(type, 10) === 1 ? '/admin/produto-agencia/' : '/admin/produto/';
      this.setState({ type, urlLoad, urlNew, urlEdit }, () => {
        this.tableList.getItems();
      });
    });
  };

  novo = () => {
    const { history } = this.props;
    const {urlNew} = this.state
      history.push(urlNew);
  };

  render() {
    const { match } = this.props;
    const {
      page,
      type,
      pageSize,
      totalItems,
      search,
      order,
      orderBy,
      urlDelete,
      urlEdit,
      urlLoad,
      customDataFilter,
    } = this.state;

    return (
      <div>
        <Breadcrumb
          title="Produtos"
          description="Gerencie os produtos DMJob."
          renderRight={(() => (
            <div className="breadcrumb-right-actions">
              <button
                type="button"
                className="bx--btn btn-secondary-color v-md-margin"
                onClick={this.novo}
              >
                Cadastrar
              </button>
            </div>
          ))()}
        />
        <section className="content-wrapper">
          <Tabs
            sections={[
              { title: 'Agência', path: `${match.url}/1` },
              // { title: 'Trade', path: `${match.url}/2` },
            ]}
          />
          <TableDefault
            search={search}
            type={type}
            order={order}
            orderBy={orderBy}
            page={page}
            pageSize={pageSize}
            totalItems={totalItems}
            urlDelete={urlDelete}
            urlEdit={urlEdit}
            urlLoad={urlLoad}
            customDataFilter={customDataFilter}
            onRef={ref => {
              this.tableList = ref;
            }}
            displayActions={false}
            enableProduct={true}
          />
        </section>
      </div>
    );
  }
}

export default List;



// WEBPACK FOOTER //
// ./src/screens/admin/Products/List.js